/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VideoAnnotationData } from './videoAnnotationData';
import { ExcelSheet } from './excelSheet';


export interface ExcelContent {
    data?: VideoAnnotationData;
    firstFrame?: number;
    frameRate?: number;
    height?: number;
    playerName?: string;
    sheets?: Array<ExcelSheet>;
    title?: string;
    weight?: number;
    width?: number;
}

